export default "__VITE_ASSET__7111c693__"